import { launchPanelApp } from './lib/PanelApp';
import PreLoginLayout from './pages/layout/PreLoginLayout';

// Page specific code :
import Registration from './pages/register/Registration';

launchPanelApp(Registration, {}, PreLoginLayout);
